/**
 * The modifier the Ctrl/⌘+F hint names: ⌘ on Apple platforms, Ctrl elsewhere.
 * Only the label depends on it — the shortcut itself accepts either key.
 */
export function shortcutModifierLabel(
  platform: string = typeof navigator === 'undefined'
    ? ''
    : navigator.platform || navigator.userAgent,
): string {
  return /Mac|iPhone|iPad/i.test(platform) ? '⌘' : 'Ctrl';
}
